var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2933 3.78306C30.9293 2.39429 29.8566 1.30054 28.4946 0.929361C26.0259 0.254883 16.1266 0.254883 16.1266 0.254883C16.1266 0.254883 6.22738 0.254883 3.7586 0.929361C2.3966 1.3006 1.32391 2.39429 0.959833 3.78306C0.29834 6.30029 0.29834 11.5522 0.29834 11.5522C0.29834 11.5522 0.29834 16.8042 0.959833 19.3214C1.32391 20.7102 2.3966 21.7584 3.7586 22.1296C6.22738 22.804 16.1266 22.804 16.1266 22.804C16.1266 22.804 26.0258 22.804 28.4946 22.1296C29.8566 21.7584 30.9293 20.7102 31.2933 19.3214C31.9548 16.8042 31.9548 11.5522 31.9548 11.5522C31.9548 11.5522 31.9548 6.30029 31.2933 3.78306ZM12.889 16.3206V6.78386L21.1628 11.5524L12.889 16.3206Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.52bf3dc12dbf0d565f54407f4521601b.svg";
export { ForwardRef as ReactComponent };